import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import useTranslation from 'Hooks/useTranslation';
import { FormHelperText } from '@mui/material';
import bytesToSize from 'Utils/BytesToSize';
import { UploadFiles } from 'Images';
import { UploadContainer, Container, ImageContainer, imageStyle } from './style';

export default function ImageUploadComponent({ callback }) {
  const { t2 } = useTranslation('EditCourse');

  const onDrop = useCallback(
    acceptedFiles => {
      const file = acceptedFiles[0];

      if (!file) return;

      callback(file);
    },
    [callback]
  );

  const { acceptedFiles, getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
    accept: 'image/jpeg,image/png',
    maxFiles: 1,
    onDrop,
  });

  const files = acceptedFiles.map(file => (
    <div key={file.path}>
      {file.path} - {bytesToSize(file.size)}
    </div>
  ));

  return (
    <>
      <Container {...getRootProps({ className: 'dropzone' })}>
        <UploadContainer>
          <input {...getInputProps()} />
          {!isDragActive && !acceptedFiles[0] && (
            <>
              <ImageContainer>
                <img src={UploadFiles} style={imageStyle} />
              </ImageContainer>
              <div>{t2('DragDropImageOne')}</div>
              <div>{t2('DragDropImageTwo')}</div>
            </>
          )}
          {isDragActive && <div>{t2('DragDropImageThree')}</div>}
          {acceptedFiles && <div>{files}</div>}
        </UploadContainer>
      </Container>
      {fileRejections.length > 0 && (
        <FormHelperText sx={{ color: 'red' }}>{t2('FormCourseThumbnailError')}</FormHelperText>
      )}
    </>
  );
}
